import styled from "styled-components";

import { Title1 } from "../Typography";

export const StyledTitle1 = styled(Title1)`
  letter-spacing: -0.4px;
`;

StyledTitle1.displayName = "StyledTitle1";
